import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, Loader2 } from "lucide-react";
import API from "../lib/api";
import { Section } from "../components/Common";

export default function ShopSuccessPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [record, setRecord] = useState(null);
  const pollCount = useRef(0);

  useEffect(() => {
    if (!sessionId) return;
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await API.get(`/shop/status/${sessionId}`);
        if (!alive) return;
        setRecord(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (pollCount.current >= 12) { setStatus("timeout"); return; }
        pollCount.current += 1;
        setTimeout(poll, 2000);
      } catch {
        setStatus("error");
      }
    };
    poll();
    return () => { alive = false; };
  }, [sessionId]);

  return (
    <Section eyebrow={t("shop.eyebrow")} title={t("shop.success_title")}>
      <div className="card-surface p-8 max-w-xl" data-testid="shop-success">
        {status === "checking" && (
          <div className="flex items-center gap-3 text-white/80" data-testid="shop-success-checking"><Loader2 className="w-5 h-5 animate-spin" /> {t("shop.confirming")}</div>
        )}
        {status === "paid" && (
          <>
            <div className="flex items-center gap-3 text-emerald-300" data-testid="shop-success-paid"><CheckCircle2 className="w-6 h-6" /> <span className="font-display text-xl">{t("shop.payment_confirmed")}</span></div>
            {record && (
              <div className="mt-3 text-sm text-white/70">
                {record.product_name} · €{Number(record.amount).toFixed(2)} · {record.currency?.toUpperCase()}
              </div>
            )}
          </>
        )}
        {status === "timeout" && (
          <div className="text-white/80 text-sm" data-testid="shop-success-timeout">{t("shop.still_confirming")}</div>
        )}
        {status === "error" && (
          <div className="text-rose-300 text-sm" data-testid="shop-success-error">{t("shop.could_not_check")}</div>
        )}
        <div className="mt-6 flex gap-3">
          <Link to="/shop" className="btn-secondary text-sm" data-testid="back-to-shop">{t("shop.back_to_shop")}</Link>
          <Link to="/" className="btn-ghost text-sm" data-testid="back-to-home">{t("shop.home")}</Link>
        </div>
      </div>
    </Section>
  );
}
